import { render, staticRenderFns } from "./RequestGoodsFactor.vue?vue&type=template&id=5e31975a&scoped=true&"
import script from "./RequestGoodsFactor.vue?vue&type=script&lang=js&"
export * from "./RequestGoodsFactor.vue?vue&type=script&lang=js&"
import style0 from "./RequestGoodsFactor.vue?vue&type=style&index=0&id=5e31975a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e31975a",
  null
  
)

export default component.exports